<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>
    {{
      'invite-signup-process-phone.component.contact_phone_header'
        | localise: 'Your Contact Phone Number'
    }}
  </h2>
  @if (!prohibitClosing) {
    <button
      mat-icon-button
      [mat-dialog-close]="false"
      type="button"
      class="close-dialog-button">
      <mat-icon>clear</mat-icon>
    </button>
  }
</div>

@if (inviteSignupProcessService.phoneForm; as form) {
  <form [formGroup]="form" (ngSubmit)="next()">
    <mat-dialog-content>
      <p>
        {{
          'invite-signup-process-phone.component.one_time_code_verify'
            | localise
              : 'We’re going to text you a one-time code to verify your identify.'
        }}
      </p>

      <mat-form-field class="full-width">
        <mat-label>{{
          'invite-signup-process-phone.component.phone'
            | localise: 'Phone number'
        }}</mat-label>
        <input
          matInput
          type="tel"
          appDisableAutofill
          mask="(000) 000-0000"
          formControlName="phoneNumber"
          #ctrl="ngControl"
          #inputPhone
          [dropSpecialCharacters]="false"
          (ngModelChange)="alreadyRegistered = false; error = ''" />
        @if (ctrl.errors?.server; as err) {
          <mat-error>{{ err }}</mat-error>
        }
      </mat-form-field>

      <div class="hint">
        {{
          'invite-signup-process-phone.component.secure_account_2fa_no_spam'
            | localise
              : "We use this to secure your account with two-factor authentication. We'll never sell your info or spam you. This must be a U.S. phone number."
        }}
      </div>
      <div>
        {{
          'invite-signup-process-phone.component.not_correct_phone_number'
            | localise
              : 'Is this not the correct phone number? Please reach out to your broker to send you a new invite with the correct phone number'
        }}
      </div>
      @if (error) {
        <p class="p-error-message p-error-message--margin">
          @switch (error) {
            @case (alreadyRegisteredText) {
              {{
                'invite-signup-process-phone.component.already_registered'
                  | localise
                    : 'It looks like that phone number is already registered with us. You can Log In, or try a different number.'
              }}
            }
            @case (waitBeforeRequestingAnotherCodeText) {
              {{
                'invite-signup-process-phone.component.please_wait_text'
                  | localise: 'Please wait '
              }}
              {{ waitBeforeRequestingAnotherCode }}
              {{
                'invite-signup-process-phone.component.please_wait_before_another_code'
                  | localise: ' seconds before requesting another code.'
              }}
            }
            @default {
              {{ error }}
            }
          }
        </p>
      }
    </mat-dialog-content>

    <div class="actions" mat-dialog-actions>
      @if (!prohibitClosing) {
        <button
          mat-button
          type="button"
          (click)="inviteSignupProcessService.close.next()">
          {{
            'invite-signup-process-phone.component.close_button'
              | localise: 'Close'
          }}
        </button>
      }
      <button
        type="submit"
        class="p-button p-button--rounded p-button--application-next"
        [disabled]="loading || form.invalid">
        {{
          'invite-signup-process-phone.component.continue_button'
            | localise: 'Continue'
        }}
      </button>
    </div>
  </form>
}
